import moment from 'moment';

const parseISO = ({date}) => {
  return new Date(moment(date).toDate());
}

function addTime({
  date, 
  time: {
    years = 0,
    month = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  }
}) {
  const newDate = new Date(date);
  newDate.setFullYear(newDate.getFullYear() + years);
  newDate.setMonth(newDate.getMonth() + month);
  newDate.setDate(newDate.getDate() + days);
  newDate.setHours(newDate.getHours() + hours);
  newDate.setMinutes(newDate.getMinutes() + minutes);
  newDate.setSeconds(newDate.getSeconds() + seconds);
  return newDate;
};

const countingExtraLeapYearDays = ({startDate, endDate}) => {
  let countDay = 0;
  for (let year = startDate.getFullYear(); year <= endDate.getFullYear(); year++) {
    if ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)) {
      const leapDay = new Date(year, 1, 29);//February 29th
      
      //Check if the day is within the range
      if (leapDay >= startDate && leapDay <= endDate) {
        endDate = addTime({
          date: endDate,
          time: {days: 1}
        });
        countDay++;
      }
    }
  }

  return countDay;
};

export const handleCalculateExtraDaysInLeapYearsDateRange = ({
  startDate,
  dayRange
}) => {
  const startDateFormatted = parseISO({date: startDate});
  
  const endDate = addTime({
    date: startDateFormatted,
    time: {days: dayRange}
  });
  
  const days = countingExtraLeapYearDays({
    startDate: startDateFormatted,
    endDate
  });

  return days;
};